import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { alpha, Card, CardContent, CardHeader, darken, getLuminance, Grid, lighten, useTheme } from '@mui/material';
import React from 'react';
import { useForm } from './FormContext';

export const FormSection = ({ title, color = 'surface.high', icon, children }) => {
  const theme = useTheme();
  const { variant } = useForm();

  let colorParts = color.split('.');
  let palette = theme.palette[colorParts.shift()];
  let cardBgColor = palette.main;
  if (colorParts.length > 0) {
    cardBgColor = palette[colorParts[0]];
  }

  const cardHeaderTexColor = palette.contrastText;

  const fieldTextColor = theme.palette.getContrastText(cardBgColor);
  const isLight = getLuminance(cardBgColor) === 1;
  const fieldBgColor =
    variant === 'outlined' ? 'transparent'
    : isLight ? darken(cardBgColor, 0.1)
    : lighten(cardBgColor, 0.5);
  const fieldLabelColor = alpha(fieldTextColor, 0.7);
  const fieldBgColorDisabled = alpha(fieldTextColor, 0.04);
  const fieldTextColorDisabled = alpha(fieldTextColor, 0.38);

  let cardSx = {
    color: cardHeaderTexColor,
    bgcolor: cardBgColor,

    '& .MuiInputLabel-root': { color: fieldLabelColor },
    '& .MuiInputBase-input': { color: fieldTextColor },
    '& .MuiInputBase-formControl': { backgroundColor: fieldBgColor },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: alpha(fieldTextColor, 0.4),
    },
    '& .MuiInputBase-formControl.Mui-disabled': {
      backgroundColor: fieldBgColorDisabled,
    },
    '& .MuiInputBase-input.Mui-disabled, & .MuiInputLabel-root.Mui-disabled': {
      WebkitTextFillColor: fieldTextColorDisabled,
    },
    '& .Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderColor: alpha(fieldTextColorDisabled, 0.1),
    },
    '.entity-form-wrapper & .MuiInputBase-formControl.Mui-disabled': {
      backgroundColor: fieldBgColor,
    },
    '.entity-form-wrapper & .MuiInputLabel-root.Mui-disabled, .entity-form-wrapper & .MuiInputBase-input.Mui-disabled':
      {
        WebkitTextFillColor: fieldTextColor,
      },
    '.entity-form-wrapper & .Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderColor: alpha(fieldTextColor, 0.4),
    },
  };

  let renderChildren = () => {
    if (React.Children.count(children) > 1) {
      return (
        <Grid
          container
          spacing={2}
          direction={'row'}
          sx={{
            justifyContent: 'flex-start',
            alignItems: 'stretch',
          }}
        >
          {React.Children.map(children, (child) => (
            <Grid size={6}>{child}</Grid>
          ))}
        </Grid>
      );
    } else {
      return children;
    }
  };
  return (
    <Card variant="standard" sx={cardSx}>
      <CardHeader
        avatar={icon && <FontAwesomeIcon icon={icon} />}
        title={title}
        slotProps={{ title: { variant: 'h5' } }}
      />
      <CardContent>{renderChildren()}</CardContent>
    </Card>
  );
};
